/**
 * ReferenceSelect · txn kit (presentation only)
 * Standardised operational-document selector. Thin pass-through over the
 * shared SearchablePicker so document pickers (WO, source batch, …) look and
 * behave identically and can show enough context (code · name · meta) to
 * identify the right record. The authoritative `value` (id) is unchanged —
 * presentation only. No data fetching / resolution logic here.
 */
import React from "react";
import SearchablePicker from "@/components/SearchablePicker";

export default function ReferenceSelect({
  options = [],
  value = "",
  onChange,
  placeholder = "Select…",
  emptyLabel = "No matches — refine your search.",
  testid = "ref-select",
  disabled = false,
  headerHint = "",
  className = "",
  popoverClassName = "min-w-[480px]",
  itemClassName = "py-2",
}) {
  return (
    <SearchablePicker
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      emptyLabel={emptyLabel}
      testid={testid}
      disabled={disabled}
      headerHint={headerHint}
      className={className}
      popoverClassName={popoverClassName}
      itemClassName={itemClassName}
    />
  );
}
